<template>
  <div :class="$style.component">
    <base-bodytext
      v-for="(column, index) in item.columns"
      :key="`column-${index}`"
      :class="$style.column"
      :text="column"
    />
  </div>
</template>

<script>
import BaseBodytext from '@/components/base-bodytext'

export default {
  components: { BaseBodytext },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" module>
.component {
  margin: var(--blank-line) 0;

  @media (min-width: $medium) {
    display: flex;
  }
}

.column {
  &:not(:last-of-type) {
    padding-bottom: var(--blank-line);
  }

  @media (min-width: $medium) {
    // display: flex;
    // flex-direction: column;
    flex: 1;

    &:not(:last-of-type) {
      padding-bottom: 0;
    }
  }
}
</style>
